// extracted by mini-css-extract-plugin
export default {"list":"symbols_list__3CZKT"};